export default {
  title: 'WinOrder',
  form: {
    store_id: {
      label: 'ID negozio: ',
    },
    url: {
      label: 'URL: ',
    },
    username: {
      label: 'Nome utente: ',
      placeholder: "Nome utente per l'autenticazione tra il tuo negozio e WinOrder",
      validation: {
        required: 'Il nome utente non può essere vuoto',
        min: 'La lunghezza minima del nome utente è di 3 caratteri',
      },
    },
    password: {
      label: 'Password: ',
      placeholder: "Password per l'autenticazione tra il tuo negozio e WinOrder",
      validation: {
        required: 'La password non può essere vuota',
        complexity: 'La password deve contenere almeno 8 caratteri e almeno una lettera',
      },
    },
  },
  labels: {
    credentials: 'Credenziali:',
  },
  instructions: {
    title: 'Istruzioni di configurazione:',
    step_1: 'Apri «Impostazioni» → «Impostazioni programma» in WinOrder.',
    step_2: 'In alto troverai il pulsante «Configurazione negozio online».',
    step_3:
      'Nella finestra successiva troverai tutti i negozi preconfigurati in WinOrder. Seleziona «FoodAmigos» e clicca su «Avanti».',
    step_4:
      'Nella finestra successiva, sostituisci <0>{{storeid_placeholder}}</0> con <1>{{company_id}}</1> nel campo «URL del servizio web». <br />Il risultato finale dovrebbe essere: <2>{{url}}</2>',
    step_5: 'Nella stessa finestra, inserisci <ClickToCopy>{{username}}</ClickToCopy> nel campo «Nome utente».',
    step_6:
      'Nella stessa finestra, inserisci <ClickToCopy>{{password}}</ClickToCopy> nel campo «Password». Poi clicca su «Avanti».',
    step_7:
      "WinOrder verifica ora la connessione all'interfaccia FoodAmigos. Clicca su «Avanti» e nella finestra successiva su «Fine».",
    step_8: 'Salva le impostazioni.',
  },
  buttons: {
    save: 'Salva',
    cancel: 'Annulla',
    edit: 'Modifica',
  },
  toasts: {
    error: 'Salvataggio modifiche non riuscito',
    success: 'Modifiche salvate',
  },
};
